module.exports = __webpack_public_path__ + "img/atalho-5.8f5872e6.png";